import ScreenContainer from './ScreenContainer'

export default ScreenContainer
